export class PremiumBenefitItemModel {
    constructor(
        public description: string,
        public tagLine: string,
        public iconUrl: string,
        public isActive: boolean,
        public order: number,
        public metaData: any
    ) {}
}
